/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HOME_CARD_CALCULATE_TEXT: 'calculators.home.card.calculate.paragraph',
  HOME_CARD_CALCULATE_TITLE: 'calculators.home.card.calculate.heading',
  HOME_CARD_PAYOFF_TEXT: 'calculators.home.card.payoff.paragraph',
  HOME_CARD_PAYOFF_TITLE: 'calculators.home.card.payoff.heading',
  HOME_TOPSECTION_TEXT: 'calculators.home.topSection.paragraph',
  HOME_TOPSECTION_TITLE: 'calculators.home.topSection.heading',
};

const enMessages = {
  // Calculators Home Cards
  [IDS.HOME_CARD_CALCULATE_TEXT]: 'Estimate how much you can save on interest by making extra payments.',
  [IDS.HOME_CARD_CALCULATE_TITLE]: 'Payoff your loan early',
  [IDS.HOME_CARD_PAYOFF_TEXT]: 'Request online payoff statements and view past statements.',
  [IDS.HOME_CARD_PAYOFF_TITLE]: 'Request a payoff statement',
  // Calculators Home Top Section
  [IDS.HOME_TOPSECTION_TEXT]: 'Explore different options to payoff your loan using our calculators.',
  [IDS.HOME_TOPSECTION_TITLE]: 'Own your home sooner.',
};

const enMurabahaMessages = {
  ...enMessages,
  // Calculators Home Cards
  [IDS.HOME_CARD_CALCULATE_TEXT]: 'Estimate how much you can save on profit by making extra payments.',
  [IDS.HOME_CARD_CALCULATE_TITLE]: 'Payoff your Murabaha Financing Transaction early',
  [IDS.HOME_CARD_PAYOFF_TEXT]: 'Request online Discounted Murabaha debt/payoff statements and view past statements.',
  [IDS.HOME_CARD_PAYOFF_TITLE]: 'Request a Discounted Murabaha debt/payoff statement',
  // Calculators Home Top Section
  [IDS.HOME_TOPSECTION_TEXT]: 'Explore different options to payoff your Murabaha Financing Transaction using our calculators.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
